var _circle, _rect, _rect2, _rect3, _mask, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimPromo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Promo Code Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.087,
    y: 27.5,
    width: 4.90991,
    height: 25.6396,
    rx: 2.45495,
    transform: "rotate(45 44.087 27.5)",
    stroke: "#000000",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.087,
    y: 40.5294,
    width: 6.44544,
    height: 6.44544,
    rx: 3.22272,
    transform: "rotate(45 44.087 40.5294)",
    stroke: "#000000",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9718,
    y: 26.4142,
    width: 6.44544,
    height: 6.44544,
    rx: 3.22272,
    transform: "rotate(45 29.9718 26.4142)",
    stroke: "#000000",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 54C11 56.2091 12.7909 58 15 58H59.5C61.7091 58 63.5 56.2091 63.5 54V45.5C59.3579 45.5 56 42.1421 56 38C56 33.8579 59.3579 30.5 63.5 30.5V22C63.5 19.7909 61.7091 18 59.5 18H15C12.7909 18 11 19.7909 11 22V30.5C15.1421 30.5 18.5 33.8579 18.5 38C18.5 42.1421 15.1421 45.5 11 45.5V54Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 45.5H65.5V43.5H63.5V45.5ZM63.5 30.5V32.5H65.5V30.5H63.5ZM11 30.5H9V32.5H11V30.5ZM11 45.5V43.5H9V45.5H11ZM15 56C13.8954 56 13 55.1046 13 54H9C9 57.3137 11.6863 60 15 60V56ZM59.5 56H15V60H59.5V56ZM61.5 54C61.5 55.1046 60.6046 56 59.5 56V60C62.8137 60 65.5 57.3137 65.5 54H61.5ZM61.5 45.5V54H65.5V45.5H61.5ZM63.5 43.5C60.4624 43.5 58 41.0376 58 38H54C54 43.2467 58.2533 47.5 63.5 47.5V43.5ZM58 38C58 34.9624 60.4624 32.5 63.5 32.5V28.5C58.2533 28.5 54 32.7533 54 38H58ZM61.5 22V30.5H65.5V22H61.5ZM59.5 20C60.6046 20 61.5 20.8954 61.5 22H65.5C65.5 18.6863 62.8137 16 59.5 16V20ZM15 20H59.5V16H15V20ZM13 22C13 20.8954 13.8954 20 15 20V16C11.6863 16 9 18.6863 9 22H13ZM13 30.5V22H9V30.5H13ZM20.5 38C20.5 32.7533 16.2467 28.5 11 28.5V32.5C14.0376 32.5 16.5 34.9624 16.5 38H20.5ZM11 47.5C16.2467 47.5 20.5 43.2467 20.5 38H16.5C16.5 41.0376 14.0376 43.5 11 43.5V47.5ZM13 54V45.5H9V54H13Z",
    fill: "#000000",
    mask: "url(#path-5-inside-1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 11.5,
    fill: "#05C379"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3902 59.8536L61.2911 67.7073L57.6097 64.1375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimPromo);
export default __webpack_public_path__ + "static/media/claim-promo.0910a0544ae569c5ea3d8c580b6c27a4.svg";
export { ForwardRef as ReactComponent };